export default (api) => {
  api.order = {
    public: {
      index: (params) => api.request({
        url: `/api/order/index`,
        type: 'get',
        params
      }),
      getById: (id) => api.request({
        url: `/api/order/${id}`,
        type: 'get',
      }),
      getByCode: (params) => api.request({
        url: `/api/order/read-by-code`,
        type: 'get',
        params
      }),
      create: (params) => api.request({
        url: `/api/order`,
        type: 'post',
        params,
        tokenTypeLimit: 'member',
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/order/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/order/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/order`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/order/${id}/update`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/order/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/order/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/order/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/order/batch`,
        type: 'delete',
        params,
      }),
    },
  }
}